import { WaitingPaymentsSummary } from '@diamond/shared/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { getWaitingPaymentsSummary } from '../queries/order';
import { useAuthStore } from '../stores';

export const WAITING_PAYMENTS_SUMMARY_QUERY_KEY = [
  'WaitingPaymentsSummary',
] as const;

export function getWaitingPaymentsSummaryOptions(
  accessToken: string,
  warehouse: string,
  enabled = true
) {
  return queryOptions<WaitingPaymentsSummary>({
    queryKey: [...WAITING_PAYMENTS_SUMMARY_QUERY_KEY, warehouse],
    queryFn: () => getWaitingPaymentsSummary(accessToken, warehouse),
    enabled: enabled && warehouse.length > 0,
    refetchOnWindowFocus: true,
  });
}

export function useWaitingPaymentsSummary(warehouse: string, enabled = true) {
  const accessToken = useAuthStore((state) => state.access_token);

  return useQuery(
    getWaitingPaymentsSummaryOptions(accessToken, warehouse, enabled)
  );
}
